import { AxiosResponse } from 'axios';
import { Repository } from '../repository';
import { FormComponent } from '../../components/cheerfypay/form/form.component';
import { Status } from '../../shared/enums/status.enum';
import { ServiceType } from '../../shared/enums/service-type.enum';

interface Service {
    serviceType: ServiceType;
    status: Status;
    remainingSeconds: number;
}

export class ServicesRepository extends Repository {
    public async getServices(
        locationId: number,
    ): Promise<Service[]> {
        const { data } = await this._backendRequest.get('/shop-service/status/', {
            params: {
                scope_locations: locationId,
            },
            headers: {
                authorization: `Token ${FormComponent.getVariable('backendToken')}`,
            },
        });

        return data?.services ?? [];
    }
}
